import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";

const teamboardAPI = createApi({
    reducerPath: "TeamBoardAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        getTeamPlanningIdByTeamId: builder.query({
            query: (teamId) => ({
                url: `/TeamPlanning/GetTeamPlanningId/?teamId=${Number(teamId)}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllTaskByTeamPlanningId: builder.mutation({
            query: (teamPlanningId) => ({
                url: `/Task/GetAllTaskByTeamPlanningId`,
                method: 'POST',
                body: transformRequest(teamPlanningId)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllStatusByTeamId: builder.query({
            query: (teamId) => ({
                url: `/Teams/GetAllStatusByTeamId/?teamId=${Number(teamId)}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),


    })
})
export const { useLazyGetTeamPlanningIdByTeamIdQuery, useGetAllTaskByTeamPlanningIdMutation,
useLazyGetAllStatusByTeamIdQuery
} = teamboardAPI;
export default teamboardAPI;